import { Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { HttpErrorResponse } from "@angular/common/http";

import { DomainService } from "services/domain.service";
import { AuthService } from '../../app/services/auth.service';

@Injectable()
export class DomainGuard implements CanActivate {
  constructor(private router: Router, private domainService: DomainService, private authService: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const routeParam = route.params.domainName;
    const isDifferentDomain = this.isDifferentDomain(routeParam);

    // Precisa deslogar (limpando o token) antes de chamar checkDomainName abaixo:
    // com o token da empresa antiga ainda anexado, a API rejeita a checagem da
    // empresa de destino com 400.
    if (isDifferentDomain) {
      this.authService.logout();
    }

    return new Promise((resolve) => {
      this.domainService.checkDomainName(routeParam).subscribe(
        (domain) => {
          if (!domain) {
            resolve(false);
            return;
          }

          this.domainService.setDomain(domain);

          if (isDifferentDomain) {
            resolve(this.router.createUrlTree([domain.domainName, "auth", "login"]));
            return;
          }

          resolve(true);
        },
        (err: HttpErrorResponse) => {
          if (err.status === 511) {
            this.router.navigate(["/error"], {
              state: { httpErrorStatus: err.status },
            });
          } else {
            this.gotInvalidDomain();
          }

          const message = err.error?.Message || err.error;
          console.error(message);

          resolve(false);
        }
      );
    });
  }

  isDifferentDomain(routeDomainName: string): boolean {
    const centralDomain = this.authService.getDomainName();
    return !!centralDomain && centralDomain !== routeDomainName?.toLowerCase();
  }

  gotInvalidDomain() {
    this.domainService.setDomain(null);
    this.router.navigateByUrl("/error");
  }
}
